import { defineStore } from 'pinia'

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    queue: [],
    activeNotification: null,
    active: false,
  }),
  actions: {
    add(notification) {
      if (Array.isArray(notification)) {
        this.queue.push(...notification.map(this.normalize))
      } else {
        this.queue.push(this.normalize(notification))
      }
      if (!this.active) {
        this.showNext()
      }
    },
    set(notification) {
      this.queue = []
      this.add(notification)
    },
    showNext() {
      if (this.queue.length > 0) {
        this.activeNotification = this.queue.shift()
        this.active = true
      } else {
        this.activeNotification = null
        this.active = false
      }
    },
    close() {
      if (!this.activeNotification) return

      this.active = false
      this.activeNotification = null
      setTimeout(() => {
        this.showNext()
      }, 0)
    },
    normalize(notification) {
      return {
        text: notification.text || notification.message || '',
        type: notification.type || '',
        title: notification.title || '',
        icon: notification.icon || '',
      }
    },
  },
})
